import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { tags as tagsApi } from "@/lib/api";

/**
 * Right rail for the Q&A surfaces: live activity, hot tags, and a
 * reputation-table stub. Each section is independent — failures
 * collapse to a quiet "no data yet" line rather than blocking the
 * page.
 */
export function RightRail() {
  return (
    <div className="space-y-6 text-sm-dense">
      <HotTags />
      <TopContributors />
    </div>
  );
}

function HotTags() {
  const q = useQuery({
    queryKey: ["tags-list"],
    queryFn: () => tagsApi.list(),
    staleTime: 60 * 1000,
  });
  const top = (q.data?.tags ?? []).slice(0, 10);
  return (
    <section>
      <h3 className="text-xs-dense font-semibold uppercase tracking-wide text-zinc-500 mb-2">
        Hot tags
      </h3>
      {q.isLoading && (
        <div className="text-xs-dense text-zinc-400">Loading…</div>
      )}
      {!q.isLoading && top.length === 0 && (
        <div className="text-xs-dense text-zinc-400">No tags yet.</div>
      )}
      <ul className="flex flex-wrap gap-1.5">
        {top.map((t) => (
          <li key={t.slug}>
            <Link
              to={`/tags/${encodeURIComponent(t.slug)}`}
              className="inline-flex items-center gap-1 text-xs-dense px-2 py-0.5 rounded bg-zinc-100 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-700"
              title={`${t.doc_count} document${t.doc_count === 1 ? "" : "s"}`}
            >
              <span>{t.slug}</span>
              <span className="text-zinc-400">×{t.doc_count}</span>
            </Link>
          </li>
        ))}
      </ul>
      {top.length > 0 && (
        <Link
          to="/tags"
          className="block mt-2 text-xs-dense text-accent hover:underline"
        >
          See all tags →
        </Link>
      )}
    </section>
  );
}

function TopContributors() {
  // Stub for v1 — reputation derivation is a follow-up. Reserving the
  // shape so adding it later is one component swap.
  return (
    <section>
      <h3 className="text-xs-dense font-semibold uppercase tracking-wide text-zinc-500 mb-2">
        Top contributors
      </h3>
      <div className="text-xs-dense text-zinc-400 italic">
        Coming soon — reputation rolling out shortly.
      </div>
    </section>
  );
}
